(function () {
  var root = document.getElementById('dandelion-homepage');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var API = 'https://api.joindandelion.com';
  var WAITLIST_KEY = 'dandelion_waitlisted';
  var RESERVED_EVENTS = ['sign_up', 'login', 'purchase', 'search', 'page_view'];

  function track(event, params) {
    try {
      var payload;
      if (RESERVED_EVENTS.indexOf(event) !== -1) {
        payload = Object.assign({ event: event }, params || {});
      } else {
        var p = params || {};
        var normalizedParams = p;
        if (p.field_name && p.field_value === undefined) {
          normalizedParams = {
            field_name: p.field_name,
            field_value: p[p.field_name]
          };
        }
        payload = {
          event: 'app_event',
          app_event_name: event,
          app_event_params: normalizedParams
        };
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }
    } catch (e) {}
  }

  function setHidden(el, hidden) {
    if (el) el.classList.toggle('hidden', hidden);
  }

  function setControlTone(el) {
    if (!el) return;
    el.style.color = el.value ? '#f3f3f3' : 'rgba(243, 243, 243, 0.7)';
  }

  /* ---- Waitlist form ---- */
  var heroEmail = root.querySelector('#hero-email');
  var heroExtra = root.querySelector('#hero-extra');
  var heroInlineBtn = root.querySelector('#hero-inline-btn');
  var form = root.querySelector('#splash-form');
  var formState = root.querySelector('#splash-form-state');
  var successState = root.querySelector('#splash-success-state');
  var submitBtn = root.querySelector('#splash-submit-btn');
  var errorEl = root.querySelector('#splash-error');
  var reasonSel = form ? form.querySelector('select[name="reason"]') : null;
  var stateSelect = form ? form.querySelector('select[name="state"]') : null;
  var otherWrap = root.querySelector('#splash-reason-other-wrap');
  var otherInput = otherWrap ? otherWrap.querySelector('input[name="reasonDetails"]') : null;
  var formStarted = false;

  function trackFormStart() {
    if (formStarted) return;
    formStarted = true;
    track('waitlist_form_start');
  }

  function setSubmitting(isSubmitting) {
    [submitBtn, heroInlineBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = isSubmitting;
      btn.textContent = isSubmitting ? 'Joining...' : 'Join our Waitlist';
    });
  }

  function showSuccess() {
    setHidden(formState, true);
    setHidden(successState, false);
  }

  try {
    if (localStorage.getItem(WAITLIST_KEY) === 'true') {
      showSuccess();
    }
  } catch (e) {}

  /* ---- Populate US states ---- */
  var states = ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"];
  states.forEach(function (s) {
    var o = document.createElement('option');
    o.textContent = s; o.style.color = '#1d1c1a';
    o.value = s;
    if (stateSelect) stateSelect.appendChild(o);
  });
  setControlTone(stateSelect);
  setControlTone(reasonSel);

  if (heroEmail) {
    heroEmail.addEventListener('focus', trackFormStart);
    heroEmail.addEventListener('input', function () {
      var show = heroEmail.value.trim().length > 0;
      setHidden(heroExtra, !show);
      setHidden(heroInlineBtn, show);
    });
    heroEmail.addEventListener('change', function () {
      track('waitlist_field_change', { field_name: 'email' });
    });
  }

  if (stateSelect) {
    stateSelect.addEventListener('focus', trackFormStart);
    stateSelect.addEventListener('change', function () {
      setControlTone(this);
      track('waitlist_field_change', { field_name: 'state', state: this.value || null });
    });
  }

  if (reasonSel) {
    reasonSel.addEventListener('focus', trackFormStart);
    reasonSel.addEventListener('change', function () {
      var isOther = this.value === 'other';
      setControlTone(this);
      setHidden(otherWrap, !isOther);
      if (otherInput) {
        otherInput.required = isOther;
        if (!isOther) otherInput.value = '';
      }
      track('waitlist_field_change', { field_name: 'reason', reason: this.value || null });
    });
  }

  if (otherInput) {
    otherInput.addEventListener('focus', trackFormStart);
    otherInput.addEventListener('change', function () {
      track('waitlist_field_change', { field_name: 'reasonDetails' });
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email ? form.email.value.trim() : '';
      var state = form.state ? form.state.value : '';
      var reason = form.reason ? form.reason.value : '';
      var reasonDetails = form.reasonDetails ? form.reasonDetails.value.trim() : '';

      track('cta_click', {
        cta: 'waitlist_join_now',
        location: 'splash_hero',
        field_name: 'cta_click',
        field_value: 'waitlist_sign_up_cta',
        has_email: !!email,
        has_state: !!state,
        has_reason: !!reason,
        reason: reason || null
      });

      if (!email || !state || !reason) {
        if (errorEl) {
          errorEl.textContent = 'Please complete the form.';
          setHidden(errorEl, false);
        }
        track('waitlist_signup_error', { stage: 'validation_missing_fields' });
        return false;
      }

      if (reason === 'other' && !reasonDetails) {
        if (errorEl) {
          errorEl.textContent = 'Please tell us a bit more.';
          setHidden(errorEl, false);
        }
        track('waitlist_signup_error', { stage: 'validation_missing_reason_details' });
        return false;
      }

      setSubmitting(true);
      setHidden(errorEl, true);

      var payload = { email: email, state: state, reason: reason };
      if (reason === 'other') payload.reasonDetails = reasonDetails;

      fetch(API + '/waitlist/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.ok) return null;
        return res.json().catch(function () { return null; }).then(function (data) {
          throw new Error(data && data.message ? data.message : 'Something went wrong');
        });
      }).then(function () {
        try {
          localStorage.setItem(WAITLIST_KEY, 'true');
        } catch (e) {}
        showSuccess();
        track('waitlist_signup_success', { reason: reason, state: state });
        track('sign_up', { method: 'waitlist', reason: reason });
      }).catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong';
          setHidden(errorEl, false);
        }
        setSubmitting(false);
        track('waitlist_signup_error', {
          stage: 'api',
          message: (err && err.message) || 'unknown'
        });
      });

      return false;
    });
  }

  /* ---- Pricing "includes" lists ---- */
  var includes = {
    living: [
      "Unlimited access to Dandie, your AI companion, via app and SMS",
      "Bank-level security and storage of information",
      "Version history and change tracking",
      "Collaboration with family members and trusted contacts"
    ],
    readonly: [
      "Bank-level security and storage of information",
      "PDF download of your completed Playbook"
    ]
  };
  function check() {
    return '<span class="mt-[3px] flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#fcc02a]"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#1d1c1a" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  }
  Object.keys(includes).forEach(function (key) {
    var box = root.querySelector('[data-includes="' + key + '"]');
    includes[key].forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'flex items-start gap-3';
      row.innerHTML = check() + '<span class="text-base leading-[1.5] text-[#4d4b48]">' + item + '</span>';
      if (box) box.appendChild(row);
    });
  });

  /* ---- Reveal on scroll ---- */
  var reveals = root.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(reveals, function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });
  }

  /* ---- Hero parallax ---- */
  var hero = root.querySelector('#hero');
  var heroImg = root.querySelector('#hero-img');
  var loveLine = root.querySelector('#love-line');
  var instrLine = root.querySelector('#instr-line');
  var ticking = false;
  function parallax() {
    ticking = false;
    if (reduce || !hero || !heroImg || !loveLine || !instrLine) return;
    var rect = hero.getBoundingClientRect();
    var total = rect.height || 1;
    var p = Math.min(1, Math.max(0, -rect.top / total));
    heroImg.style.transform = 'translateY(' + (p * 18) + '%) scale(' + (1.05 + p * 0.10) + ')';
    loveLine.style.transform = 'translateX(' + (p * -14) + '%)';
    instrLine.style.transform = 'translateX(' + (p * 14) + '%)';
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(parallax); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  parallax();

  /* ---- Capability carousel ---- */
  var capTrack = root.querySelector('#cap-track');
  if (!capTrack) return;
  var capCards = capTrack.querySelectorAll('.cap-card');
  var capDesktop = window.matchMedia('(min-width: 640px)');
  var capActive = 0, capTimer = null, capStarted = false;
  function setCapActive(i) {
    capActive = (i + capCards.length) % capCards.length;
    Array.prototype.forEach.call(capCards, function (c, idx) {
      c.classList.toggle('active', idx === capActive);
    });
  }
  function capStep() {
    setCapActive(capActive + 1);
    capTimer = window.setTimeout(capStep, 8000);
  }
  function startCap() {
    if (capStarted || reduce || !capDesktop.matches) return;
    capStarted = true;
    capTrack.classList.add('cycling');
    setCapActive(0);
    capTimer = window.setTimeout(capStep, 8000);
  }
  function stopCap() {
    capStarted = false;
    if (capTimer) window.clearTimeout(capTimer);
    capTrack.classList.remove('cycling');
  }
  Array.prototype.forEach.call(capCards, function (c, idx) {
    c.querySelector('.cap-btn').addEventListener('click', function () {
      if (!capDesktop.matches || reduce) return;
      if (capTimer) window.clearTimeout(capTimer);
      setCapActive(idx);
      capTimer = window.setTimeout(capStep, 8000);
    });
  });
  if ('IntersectionObserver' in window) {
    var capIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) startCap(); });
    }, { threshold: 0.5 });
    capIo.observe(capTrack);
  } else { startCap(); }
  capDesktop.addEventListener('change', function () {
    stopCap();
    if (capDesktop.matches) startCap();
  });
  function capScroll(dir) {
    var card = capTrack.querySelector('.cap-card');
    var gap = parseFloat(getComputedStyle(capTrack).columnGap) || 0;
    var amount = card ? card.offsetWidth + gap : capTrack.clientWidth;
    var max = capTrack.scrollWidth - capTrack.clientWidth;
    var b = reduce ? 'auto' : 'smooth';
    if (dir === 1 && capTrack.scrollLeft >= max - 4) { capTrack.scrollTo({ left: 0, behavior: b }); return; }
    if (dir === -1 && capTrack.scrollLeft <= 4) { capTrack.scrollTo({ left: max, behavior: b }); return; }
    capTrack.scrollBy({ left: dir * amount, behavior: b });
  }
  root.querySelector('[data-cap-prev]').addEventListener('click', function () { capScroll(-1); });
  root.querySelector('[data-cap-next]').addEventListener('click', function () { capScroll(1); });

  /* ---- Gathers rotator ---- */
  var gathers = ["legal documents.","guardianship decisions.","healthcare wishes.","children's information.","pet care instructions.","trusted contacts.","important records.","digital accounts.","emergency information.","personal messages.","legacy wishes."];
  var ITEM_EM = 1.18;
  var GATHER_INTERVAL_MS = 1400;
  var GATHER_TRANSITION_MS = 600;
  var GATHER_RESET_DELAY_MS = GATHER_TRANSITION_MS + 20;
  var wheel = root.querySelector('#gathers-wheel');
  if (!wheel) return;
  if (typeof wheel._gathersCleanup === 'function') wheel._gathersCleanup();
  wheel.textContent = '';
  var loop = gathers.concat(gathers, gathers);
  loop.forEach(function (t) {
    var d = document.createElement('div');
    d.className = 'flex items-center whitespace-nowrap';
    d.style.height = ITEM_EM + 'em';
    d.style.transition = 'opacity .5s';
    d.textContent = t;
    wheel.appendChild(d);
  });
  var wheelItems = wheel.children;
  var gIdx = gathers.length;
  function renderWheel(animate) {
    wheel.style.transition = animate ? 'transform ' + GATHER_TRANSITION_MS + 'ms cubic-bezier(.16,1,.3,1)' : 'none';
    wheel.style.transform = 'translateY(' + (-gIdx * ITEM_EM) + 'em)';
    for (var i = 0; i < wheelItems.length; i++) {
      wheelItems[i].style.opacity = (i === gIdx) ? '1' : '0.3';
    }
  }
  if (reduce) {
    gIdx = 0; renderWheel(false);
  } else {
    renderWheel(false);
    var gWheelTimer = null, gResetTimer = null, gIo = null;
    function gTick() {
      gIdx++;
      renderWheel(true);
      if (gIdx >= gathers.length * 2) {
        if (gResetTimer) window.clearTimeout(gResetTimer);
        gResetTimer = window.setTimeout(function () {
          gIdx -= gathers.length;
          renderWheel(false);
          gResetTimer = null;
        }, GATHER_RESET_DELAY_MS);
      }
    }
    function startGathers() { if (!gWheelTimer) gWheelTimer = window.setInterval(gTick, GATHER_INTERVAL_MS); }
    function stopGathers() {
      if (gWheelTimer) { window.clearInterval(gWheelTimer); gWheelTimer = null; }
      if (gResetTimer) { window.clearTimeout(gResetTimer); gResetTimer = null; }
    }
    wheel._gathersCleanup = function () {
      stopGathers();
      if (gIo) gIo.disconnect();
    };
    if ('IntersectionObserver' in window) {
      gIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.intersectionRatio >= 0.35) startGathers(); else stopGathers();
        });
      }, { threshold: [0, 0.35, 1] });
      gIo.observe(root.querySelector('#gathers'));
    } else { startGathers(); }
  }

  /* ---- Misconceptions carousel ---- */
  var miscTrack = root.querySelector('#misc-track');
  if (!miscTrack) return;
  var miscBgs = root.querySelectorAll('.misc-bg');
  function updateMisc() {
    var card = miscTrack.querySelector('[data-card]');
    var gap = parseFloat(getComputedStyle(miscTrack).columnGap) || 0;
    var step = card ? card.offsetWidth + gap : miscTrack.clientWidth;
    if (step <= 0) return;
    var idx = Math.round(miscTrack.scrollLeft / step);
    idx = Math.max(0, Math.min(miscBgs.length - 1, idx));
    Array.prototype.forEach.call(miscBgs, function (b, i) { b.classList.toggle('active', i === idx); });
  }
  function miscScroll(dir) {
    var card = miscTrack.querySelector('[data-card]');
    var gap = parseFloat(getComputedStyle(miscTrack).columnGap) || 0;
    var amount = card ? card.offsetWidth + gap : miscTrack.clientWidth;
    var max = miscTrack.scrollWidth - miscTrack.clientWidth;
    var b = reduce ? 'auto' : 'smooth';
    if (dir === 1 && miscTrack.scrollLeft >= max - 4) { miscTrack.scrollTo({ left: 0, behavior: b }); return; }
    if (dir === -1 && miscTrack.scrollLeft <= 4) { miscTrack.scrollTo({ left: max, behavior: b }); return; }
    miscTrack.scrollBy({ left: dir * amount, behavior: b });
  }
  miscTrack.addEventListener('scroll', function () { window.requestAnimationFrame(updateMisc); }, { passive: true });
  window.addEventListener('resize', updateMisc);
  root.querySelector('[data-misc-prev]').addEventListener('click', function () { miscScroll(-1); });
  root.querySelector('[data-misc-next]').addEventListener('click', function () { miscScroll(1); });
  updateMisc();

})();
